import { createSlotsContext } from '@grandvisionhq/slots';

const [CartSummaryActionSlotsProvider, useCartSummaryActionSlots] = createSlotsContext({
    displayName: 'CartSummaryActionSlotsContext'
});

export { CartSummaryActionSlotsProvider, useCartSummaryActionSlots };
//# sourceMappingURL=context.js.map
